var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("c-table", {
        ref: "table",
        attrs: {
          title: "선택 공정의 HAZOP 미조치 Punch-list",
          columns: _vm.grid.columns,
          data: _vm.grid.data,
          gridHeight: "450px",
          filtering: false,
          columnSetting: false,
          isFullScreen: false,
          usePaging: false,
          expandAll: true,
          "hide-bottom": true,
        },
        on: { linkClick: _vm.linkClick },
      }),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }